import { render, staticRenderFns } from "./UploadWallpaper.vue?vue&type=template&id=76c49b20&"
import script from "./UploadWallpaper.vue?vue&type=script&lang=js&"
export * from "./UploadWallpaper.vue?vue&type=script&lang=js&"
import style0 from "./UploadWallpaper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports